import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Button, {
  ButtonVariant,
  ButtonSize,
} from "common/basicComponents/Button";
import { IconName } from "common/basicComponents/Icon";
import Typography, {
  TypographyVariant,
} from "common/basicComponents/Typography";

const Cell = styled.td`
  height: 4rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};
  text-align: ${({ centered }) => (centered ? "center" : "left")};
`;

const ButtonsCell = styled(Cell)`
  min-width: 6.25rem;
  width: 6.25rem;
  button {
    display: inline-flex;
    margin: 0 0.25rem;
  }
`;

const DomainRow = ({ data, disabled, onEdit, onDelete }) => {
  return (
    <>
      <Cell>
        <Typography
          variant={TypographyVariant.BODY2}
          text={data.domainUrl}
          tag="span"
        />
      </Cell>
      <ButtonsCell centered={true}>
        <Button
          icon={IconName.EDIT}
          variant={ButtonVariant.TEXT}
          size={ButtonSize.XSMALL}
          onClick={() => onEdit(data)}
          disabled={disabled}
        />
        <Button
          icon={IconName.TRASH}
          variant={ButtonVariant.TEXT}
          size={ButtonSize.XSMALL}
          onClick={() => onDelete(data)}
          disabled={disabled}
        />
      </ButtonsCell>
    </>
  );
};

DomainRow.propTypes = {
  data: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DomainRow.defaultProps = {
  disabled: false,
};

export default DomainRow;
